export default {
  bg: "white",
  boxShadow: "lg",
  ".nice-dates-day:before": {
    bg: "goldPrimary",
  },
  ".nice-dates-day:after": {
    borderWidth: "default",
    borderStyle: "solid",
    borderColor: "goldPrimary",
  },
  ".nice-dates-navigation_current": {
    textTransform: "uppercase",
    fontWeight: "medium",
    fontSize: "fs14",
    letterSpacing: "loose200",
  },
  ".nice-dates-navigation_next, .nice-dates-navigation_previous": {
    ":before": {
      width: 22,
      height: 14,
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20.602' height='12.41' viewBox='0 0 20.602 12.41'%3E%3Cg fill='none' stroke='%23C98E4A' stroke-width='1.5'%3E%3Cpath d='M0 6.183h19.368M13.867.53l5.675 5.675-5.675 5.675'/%3E%3C/g%3E%3C/svg%3E%0A")`,
      backgroundPosition: "center center",
      backgroundSize: "cover",
      border: 0,
      transform: "none",
      transition: "none",
    },
  },
  ".nice-dates-navigation_previous": {
    ":before": {
      transform: "rotate(180deg)",
    },
  },
  "span, div, p, a": {
    fontFamily: "textSans",
  },
  ".nice-dates-day_date": {
    fontWeight: "regular",
  },
  ".-selected .nice-dates-day_date": {
    fontWeight: "medium",
  },
  ".nice-dates-day_month": {
    marginTop: "-4px",
  },
};

export const php = {
  variant: "calendars.default",
  width: ["full", 448],
  height: ["full", "auto"],
  bg: ["transparent", "white"],
  display: ["flex", "block"],
  flexDirection: "column",
  justifyContent: "center",
  boxShadow: [null, "lg"],
  pb: [null, "s400"],
};

export const phpCancellation = {
  variant: "calendars.default",
  position: ["relative", null, "absolute"],
  bottom: ["auto", null, "calc(-100% - 132px)"],
  right: ["auto", null, 0],
  width: ["full", null, 528],
  height: ["full", null, "auto"],
  display: ["flex", null, "block"],
  flexDirection: "column",
  justifyContent: "center",
  boxShadow: ["none", null, "lg"],
  pb: [0, null, "s400"],
  zIndex: 9,
};
